var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"myModalRef",attrs:{"size":"md","hide-footer":"","title":_vm.entry.title}},[_c('label-input',{attrs:{"initialValues":_vm.entry.tags},on:{"labelUpdated":_vm.updateTags}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }